///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="report-dp005-product-variants.collection.ts"/>
///<reference path="../models/dp005-product.model.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IProductWithLabelCount = Meevo.Plugins.Reports.IProductWithLabelCount;
    import IReportDP005Product = Meevo.Plugins.Reports.IReportDP005Product;

    interface ICriteria {
        VariantList_TBL: string[];
        ProductState_TBL: string[];
    }

    interface IReportModel {
        BasedOnOnhand: boolean;
        CurrentUserId: string;
        IncludeBarcode: boolean;
        IncludePrice: boolean;
        IncludeRetail: boolean;
        IncludeShopSupply: boolean;
        LabelsStartPosition: number;
        ManufacturerList_TBL: string[];
        NumberOfLabels: number;
        OnlyProductsCreatedOrUpdatedByCurrentUser: boolean;
        OnlyProductsCreatedOrUpdatedToday: boolean;
        ProductCatList_TBL: string[]
        ProductListWithLabelCounts_TBL: string[];
        SpecificNumber: boolean;
    }

    export class ReportDp005ProductsCollection extends ReportDp005ProductVariantsCollection implements IApiCollection<IReportDP005Product> {

        protected criteria: ICriteria;
        protected reportModel: IReportModel;

        protected get CollectionModel() {
            return Dp005ProductModel;
        }

        constructor(public connectedModel: ModelValueType[], items: IReportDP005Product[] = [], options: ICollectionOptions<IReportDP005Product> = {}, $scope: ng.IScope) {
            super(connectedModel, items, options, $scope);

            this.reportModel = options.reportModel as IReportModel;
        }

        protected getOnHandValueByVariantId(variantId: string): number {
            if (this.reportModel.SpecificNumber) {
                return this.reportModel.NumberOfLabels;
            }

            const product = this.allModelsList.find(model => model.get('variant_TId') === variantId);

            if (!product) return 0;

            return product.get('numberOfLabels') || 0;
        }

        protected modelIsSelected(model: Dp005ProductModel, modelValues: IProductWithLabelCount[]): boolean {
            return modelValues.filter(row => row.variant_TId === model.get('variant_TId')).length > 0;
        }

        public fetch(dataService: Meevo.Components.BaseClasses.IDataService = this.dataService): ng.IPromise<IReportDP005Product[]> {
            this.dataService = dataService;

            if (!this.criteriaIsValid()) {
                return dataService.Promise.resolve([]);
            }

            return dataService
                .getListPaged<IReportDP005Product, any>(this.url, { criteria: this.criteria, itemsPerPage: 50000 })
                .then((data) => _(data).sortBy((product) => {
                    return product.sku
                }));
        }

        public onModelValueChanged = _.debounce(() => {
            this.$scope.$apply(() => {
                this._selectedModels = this.allModelsList.filter((model) => model.selected);

                this._value = this.selectedModels.map(model => ({
                    productDisplayName: model.get('productDisplayName'),
                    product_TId: model.get('product_TId'),
                    variantDisplayName: model.get('variantDisplayName') ? model.get('variantDisplayName') : null,
                    sku: model.get('sku'),
                    variant_TId: model.get('variant_TId'),
                    numberOfLabels: this.getOnHandValueByVariantId(model.get('variant_TId')),
                    barCode: model.get('barCode'),
                    generalDisplayName: model.displayName
                }));

                this.resetCollection(this.value);
            });
        }, 100);

        setWatchers() {
        }
    }

}
